import { css, cx } from '@emotion/css';
import React from 'react';

export interface ButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  children: React.ReactNode;
}

const defaultButton = css({
  fontSize: 'var(--fs-350)',
  fontWeight: 600,
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.5ch',
  padding: '0.55rem 1.1rem',
  borderRadius: 999,
  background: 'var(--pc-600)',
  color: 'var(--primary-color)',
  border: '1px solid var(--pc-600)',
  cursor: 'pointer',
  lineHeight: 1.1,
  transition: 'background .2s ease, box-shadow .2s ease, transform .15s ease',
  textDecoration: 'none',
  boxShadow: 'var(--shadow-200)',
  justifyContent: 'center',
  ':hover': {
    background: 'var(--pc-500)',
  },
  ':active': {
    transform: 'translateY(1px)',
  },
  ':focus-visible': {
    outline: '2px solid var(--pc-400)',
    outlineOffset: '2px',
  },
  ':disabled': {
    opacity: 0.6,
    cursor: 'not-allowed',
    ':hover': {
      background: 'var(--pc-600)',
    },
    ':active': {
      transform: 'none',
    },
  },
});

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, style, children, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        className={cx(defaultButton, className)}
        style={style}
        {...rest}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';

export default Button;